import { render } from "./dui_record.vue?vue&type=template&id=6e05d812"
import script from "./dui_record.vue?vue&type=script&lang=js"
export * from "./dui_record.vue?vue&type=script&lang=js"

import exportComponent from "E:\\zhaojiaming\\smz2023\\fashengren\\speaker_h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__